import loadTypes from 'utils/loadTypes'
import formatDate from 'date-fns/format'
import metricNames from './metricNames'
import {groupByChannels, processTotal} from './utils'

export const INSIGHT_ORDERS = loadTypes('INSIGHT_ORDERS')
export const INSIGHT_TOTAL_CURRENT_ORDERS = loadTypes('INSIGHT_TOTAL_CURRENT_ORDERS')
export const INSIGHT_TOTAL_PREVIOUS_ORDERS = loadTypes('INSIGHT_TOTAL_PREVIOUS_ORDERS')
export const INSIGHT_ORDERS_METRIC = 'INSIGHT_ORDERS_METRIC'
export const INSIGHT_ORDERS_COST_METRIC = 'INSIGHT_ORDERS_COST_METRIC'
export const INSIGHT_ORDERS_SORTING = 'INSIGHT_ORDERS_SORTING'

const initialState = {
  data: null,
  sortKey: 'orderCountSum',
  sortDirection: 'desc',
  isFetching: false,
  selectedMetric: null,
  selectedCostMetric: null,
  totalCurrent: null,
  totalPrevious: null
}

function processOrders(request, response) {
  if (!response) return null
  const [metric] = request.queryParams.metrics
  const channels = groupByChannels(response)

  return Object.keys(channels).reduce((acc, key) => {
    const channelData = channels[key]
    const {channel, channelGroup} = channelData[0].dimensions
    acc[`${channelGroup}/${channel}`] = channelData.reduce((acc, day) => {
      acc[formatDate(day.day, 'YYYY-MM-DD')] = {
        [metricNames[metric]]: day[metric]
      }
      return acc
    }, {})
    return acc
  }, {})
}

export default function(state = initialState, action) {
  switch (action.type) {
    case INSIGHT_ORDERS.REQUEST:
      return {
        ...state,
        data: null,
        isFetching: true
      }
    case INSIGHT_ORDERS.SUCCESS:
      return {
        ...state,
        data: processOrders(action.request, action.response),
        isFetching: false
      }
    case INSIGHT_ORDERS.FAILURE:
      return {
        ...state,
        data: null,
        isFetching: false
      }
    case INSIGHT_ORDERS_SORTING:
      return {
        ...state,
        ...{
          sortKey: action.sortKey,
          sortDirection: action.sortDirection
        }
      }
    case INSIGHT_ORDERS_METRIC:
      return {
        ...state,
        selectedMetric: action.selectedMetric
      }
    case INSIGHT_ORDERS_COST_METRIC:
      return {
        ...state,
        selectedCostMetric: action.selectedMetric
      }

    case INSIGHT_TOTAL_CURRENT_ORDERS.SUCCESS:
      return {
        ...state,
        totalCurrent: processTotal(action.request, action.response)
      }

    case INSIGHT_TOTAL_PREVIOUS_ORDERS.SUCCESS:
      return {
        ...state,
        totalPrevious: processTotal(action.request, action.response)
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./client/redux/modules/insights/orders.js